import React from 'react'
import styled from '@emotion/styled'

import {Box} from '@vio/atlas/helpers/Box'
import {SkeletonLoader} from '@vio/atlas/SkeletonLoader'
import {cssTheme} from '@vio/atlas/themes'

import {OfferLayoutBaseProps, OfferLayoutLoadingProps} from '.'
import {useCashbackPositioning} from './useCashbackPositioning'

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`
const ContentWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`
const LeftWrapper = styled.div`
  margin-right: ${cssTheme.layout.spacing.s400};
`
const RightWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: flex-end;
`
const CTAWrapper = styled.div`
  width: 100%;
`

export const PrimaryMultiColumnFullWidthCTALayout: React.FC<
  OfferLayoutBaseProps | OfferLayoutLoadingProps
> = ({
  isLoading,
  priceComponent,
  cashbackComponent,
  providerLogoComponent,
  ctaComponent,
  roomLabelsComponent,
  tagComponent,
  dataId
}) => {
  const {showCashbackOnLeft, showCashbackOnRight} = useCashbackPositioning({
    cashbackComponent
  })

  if (isLoading)
    return (
      <Wrapper>
        <Box paddingTop="s200">
          <ContentWrapper>
            <div>
              <SkeletonLoader width={139} />
              <SkeletonLoader width={160} />
            </div>
            <div>
              <SkeletonLoader width={75} align="right" />
              <SkeletonLoader width={96} align="right" />
            </div>
          </ContentWrapper>
        </Box>
        <Box marginTop="s600">
          <SkeletonLoader />
        </Box>
      </Wrapper>
    )

  return (
    <Wrapper data-id={dataId}>
      <ContentWrapper>
        <LeftWrapper>
          {tagComponent}
          {providerLogoComponent}
          {roomLabelsComponent}
          {showCashbackOnLeft}
        </LeftWrapper>
        <RightWrapper>
          {priceComponent}
          {showCashbackOnRight}
        </RightWrapper>
      </ContentWrapper>
      <CTAWrapper>{ctaComponent}</CTAWrapper>
    </Wrapper>
  )
}
